import React, { useEffect, useState } from 'react'
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import Select from 'react-select';
import axios from 'axios';
import ToastNotification from '../../../components/ToastNotification';
import ConfirmDialog from '../../../components/ConfirmDialog';
import { useLoading } from '../../../context/LoadingContext';
import { Modal, Button } from 'react-bootstrap';
import { GoDownload } from "react-icons/go";
import jsPDF from "jspdf";
import { Document, Packer, Paragraph, TextRun } from "docx";
import { saveAs } from "file-saver";

import socket from "../../../socket";


const NoticeBoard = () => {
    // ===================useStates===========================
    const { setLoading } = useLoading();
    const [noticeList, setNoticeList] = useState([]);
    const [companyDetail, setCompanyDetail] = useState(null);

    const fetchCompany = async () => {
        const companyID = localStorage.getItem("companyID");
        if (companyID) {
            try {
                const res = await axios.get(`https://api.skyguard.group/api/fetch-company-localData/${companyID}`);
                setCompanyDetail(res.data);
            } catch (err) {
                console.log("Error fetching company details:", err);
            }
        }
    };
    const [searchTerm, setSearchTerm] = useState('');
    const [showForm, setShowForm] = useState(false);
    const [departments, setDepartments] = useState([]);
    const [allRoles, setAllRoles] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [toast, setToast] = useState({
        show: false,
        message: '',
        bg: 'success'
    });
    const [confirmDialog, setConfirmDialog] = useState({
        show: false,
        title: '',
        message: '',
        onConfirm: null,
    });
    const [showNoticeModal, setShowNoticeModal] = useState(false);
    const [selectedNotice, setSelectedNotice] = useState('');

    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    }
    const [formData, setFormData] = useState({
        notice_date: getTodayDate(),
        notice_description: '',
        department: '',
        role: ''
    })


    useEffect(() => {

  socket.on("new-notice", (data) => {


    setNoticeList(prev => [
      ...prev,
      data
    ]);

    showToast(data.message, "info");
  });

  return () => {
    socket.off("new-notice");
  };

}, []);

    // ===================handlers============================
    const showToast = (message, bg = 'success') => {
        setToast({ show: true, message, bg });
    };
    const showConfirmDialog = ({ title, message, onConfirm }) => {
        setConfirmDialog({
            show: true,
            title,
            message,
            onConfirm: () => {
                onConfirm();
                setConfirmDialog({ ...confirmDialog, show: false });
            },
        });
    };

    const empData = JSON.parse(localStorage.getItem("empData") || "{}");
    const userRole = localStorage.getItem("role");
    const isAdminUser = !empData?.department || userRole === "admin" || userRole === "superadmin" || Boolean(localStorage.getItem("adminData"));

    const permissionFilteredData = noticeList.filter(notice => {
        if (isAdminUser) return true;
        if (!notice.department || notice.department === "All") return true;
        return notice.department === empData.department;
    });

    const filteredData = permissionFilteredData.filter(itm =>
        Object.values(itm).some(val =>
            String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
    )

    const handleFormOpen = () => {
        setShowForm(true);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            if (isEditing) {
                const res = await axios.put(`https://api.skyguard.group/api/update-notice/${editingId}`, formData);
                // console.log("Server response", res.data.message);
                showToast('Notice Updated Successfully', 'success');

                setNoticeList(prev =>
                    prev.map(itm => itm.id === editingId ? { id: editingId, ...formData } : itm)
                );

            } else {
                const res = await axios.post('https://api.skyguard.group/api/add-notice', formData);
                // console.log("Server reponse", res.data.message);
                showToast('Notice Added Successfully', 'success');

                setNoticeList(prev => [
                    ...prev,
                    { id: res.data.insertId, ...formData }
                ]);
            }

            fetchNotices();
            resetForm();

        } catch (error) {
            console.error(error);
            showToast('Error Adding Notice', 'danger');
        }
    }

    const resetForm = () => {
        setFormData({
            notice_date: getTodayDate(),
            notice_description: '',
            department: '',
            role: ''
        });
        setShowForm(false);
        setIsEditing(false);
        setEditingId(null);
    }

    const handleEdit = (id) => {
        const data = noticeList.find(item => item.id === id);

        setFormData({
            notice_date: data.notice_date ? data.notice_date.split('T')[0] : getTodayDate(),
            notice_description: data.notice_description || '',
            department: data.department || '',
            role: data.role || ''
        });

        setEditingId(id);
        setIsEditing(true);
        setShowForm(true);
    }

    const handleDelete = async (id) => {
        try {
            await axios.delete(`https://api.skyguard.group/api/delete-notice/${id}`)
            showToast('Notice deleted successfully', 'success');
            fetchNotices();
            setNoticeList(prev => prev.filter(item => item.id !== id));

            if (isEditing && editingId === id) resetForm();
        } catch (error) {
            console.error('Error deleting loan:', error);
            showToast('Failed to delete Notice', 'danger');
        }
    }

    // =======================apis=========================
    const fetchDepartment = async () => {
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-role');
            const data = res.data?.result || [];
            // console.log(res.data.result);

            setAllRoles(data);

            // unique departments with 'All' option
            const uniqueDepartments = [
                { value: "All", label: "All Departments" },
                ...new Map(
                    data.map((item) => [
                        item.department,
                        { value: item.department, label: item.department },
                    ])
                ).values(),
            ];

            setDepartments(uniqueDepartments);

        } catch (error) {
            console.error('Error fetching Department', error);
        }
    };

    const getFilteredRoles = () => {
        if (!formData.department) return [];

        if (formData.department === "All") {
            const uniqueRoles = [
                { value: "All", label: "All Roles" },
                ...new Map(
                    allRoles
                        .filter(item => item.role && item.role.trim() !== "")
                        .map(item => [item.role, { value: item.role, label: item.role }])
                ).values()
            ];
            return uniqueRoles;
        }

        return [
            { value: "All", label: "All Roles" },
            ...allRoles
                .filter(item => item.department === formData.department && item.role.trim() !== "")
                .map(item => ({
                    value: item.role,
                    label: item.role
                }))
        ];
    };

    const fetchNotices = async () => {
        setLoading(true);
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-notice');
            const data = (res.data?.result || []).sort((a, b) => (b.id - a.id) || (new Date(b.notice_date) - new Date(a.notice_date)));
            setNoticeList(data);
        } catch (error) {
            console.error("Error fetching Notices", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchCompany();
        fetchDepartment();
        fetchNotices();
    }, [])


    const handleDownloadNotice = (notice) => {
        if (!notice) return;

        try {
            const doc = new jsPDF();
            const pageWidth = doc.internal.pageSize.getWidth();

            // Header Banner Letterhead
            doc.setFillColor(33, 37, 41);
            doc.rect(0, 0, pageWidth, 26, "F");

            // Company Name Letterhead
            doc.setTextColor(255, 255, 255);
            doc.setFont("helvetica", "bold");
            doc.setFontSize(15);
            const adminData = JSON.parse(localStorage.getItem("adminData") || "{}");
            const resolvedCompanyName = (companyDetail?.name || companyDetail?.company_name || adminData?.user?.company_name || adminData?.company_name || "Skyguard").toUpperCase();
            doc.text(resolvedCompanyName, pageWidth / 2, 11, { align: "center" });

            doc.setFontSize(9);
            doc.setFont("helvetica", "normal");
            doc.text("Official Notice Board / Corporate Communication", pageWidth / 2, 19, { align: "center" });

            // Document Title
            doc.setTextColor(33, 37, 41);
            doc.setFont("helvetica", "bold");
            doc.setFontSize(14);
            doc.text("NOTICE", pageWidth / 2, 38, { align: "center" });
            doc.setLineWidth(0.5);
            doc.line(pageWidth / 2 - 20, 41, pageWidth / 2 + 20, 41);

            // Metadata Box
            doc.setFillColor(245, 247, 250);
            doc.roundedRect(14, 46, pageWidth - 28, 30, 2, 2, "F");
            doc.setDrawColor(220, 224, 230);
            doc.roundedRect(14, 46, pageWidth - 28, 30, 2, 2, "S");

            doc.setFontSize(10);
            doc.setFont("helvetica", "bold");
            doc.text("Notice ID:", 20, 54);
            doc.setFont("helvetica", "normal");
            doc.text(`NOT-${String(notice.id || "").padStart(4, "0")}`, 45, 54);

            doc.setFont("helvetica", "bold");
            doc.text("Date:", pageWidth / 2 + 10, 54);
            doc.setFont("helvetica", "normal");
            doc.text(notice.notice_date ? new Date(notice.notice_date).toLocaleDateString() : "N/A", pageWidth / 2 + 35, 54);

            doc.setFont("helvetica", "bold");
            doc.text("Department:", 20, 62);
            doc.setFont("helvetica", "normal");
            doc.text(notice.department || "All Departments", 45, 62);

            doc.setFont("helvetica", "bold");
            doc.text("Role:", pageWidth / 2 + 10, 62);
            doc.setFont("helvetica", "normal");
            doc.text(notice.role || "All Roles", pageWidth / 2 + 35, 62);

            // Notice Content Heading
            doc.setFont("helvetica", "bold");
            doc.setFontSize(11);
            doc.text("Notice Details / Description:", 14, 86);

            // Content text with line wrapping
            doc.setFont("helvetica", "normal");
            doc.setFontSize(10);
            const descriptionLines = doc.splitTextToSize(
                notice.notice_description || "No description provided.",
                pageWidth - 28
            );
            doc.text(descriptionLines, 14, 94);

            const contentHeight = descriptionLines.length * 6;
            const signatoryY = Math.max(110 + contentHeight, 220);

            // Signatory Block
            doc.setFont("helvetica", "normal");
            doc.text("This is an official document issued for company records and notice.", 14, signatoryY - 15);

            doc.setFont("helvetica", "bold");
            doc.text("Authorized Signatory", pageWidth - 65, signatoryY);
            doc.setFont("helvetica", "normal");
            doc.text((companyDetail?.name || companyDetail?.company_name || "Skyguard"), pageWidth - 65, signatoryY + 6);

            // Footer line
            doc.setDrawColor(200, 200, 200);
            doc.line(14, 280, pageWidth - 14, 280);
            doc.setFontSize(8);
            doc.setTextColor(128, 128, 128);
            doc.text("Skyguard ERP System • Generated electronically", pageWidth / 2, 285, { align: "center" });

            doc.save(`Notice_${(notice.department || "All").replace(/\s+/g, "_")}_${notice.notice_date || notice.id}.pdf`);
        } catch (err) {
            console.error("PDF download error:", err);
        }
    };

    return (
        <>
            <div className='main-section'>
                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                    <h3 className='my-3 fw-bold fs-5 golos'>Notice Board</h3>

                    <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
                        <div className="col-12 col-md-5">
                            <input
                                type="text"
                                className="form-control border-0 border-bottom border-dark"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />

                        </div>
                        <div className="col-12 col-md-2 d-flex justify-content-end">
                            <button className='btn btn-success' onClick={handleFormOpen}>
                                <AiOutlinePlusCircle size={20} /> Add Notice
                            </button>
                        </div>
                    </div>

                    {showForm && (
                        <div className='card p-3 my-3 shadow-sm bg-white border'>
                            <form onSubmit={handleSubmit}>
                                <div className='row g-3'>

                                                          {isEditing && (
  <div className="mb-3">
    {/* <label>Company  Name:</label> <br /> */}
    <span className="badge bg-primary px-3 py-2">
     {formData.notice_date}
    </span>
  </div>
)}
                                    {/* Select Department */}
                                    <div className='col-md-6'>
                                        <label className="form-label fw-medium">Select Department</label>
                                        <Select
                                            options={departments}
                                            value={
                                                formData.department
                                                    ? { value: formData.department, label: formData.department }
                                                    : null
                                            }
                                            onChange={(selectedOption) => {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    department: selectedOption ? selectedOption.value : '',
                                                    role: '',
                                                }));
                                            }}
                                            placeholder="Select Department..."
                                        />
                                    </div>
                                    {/* Select 	Role */}
                                    <div className='col-md-6'>
                                        <label className="form-label fw-medium">Select Role</label>
                                        <Select
                                            options={getFilteredRoles()}
                                            value={
                                                formData.role
                                                    ? { value: formData.role, label: formData.role }
                                                    : null
                                            }
                                            onChange={(selectedOption) => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    role: selectedOption ? selectedOption.value : '',
                                                }));
                                            }}
                                            placeholder="Select Role..."
                                        />
                                    </div>
                                    {/* Notice Apply Date< */}
                                    <div className="col-md-6">
                                        <label htmlFor='notice_date' className="form-label fw-medium">Notice Apply Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="notice_date"
                                            id='notice_date'
                                            value={formData.notice_date}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className='row g-3 mt-2'>
                                    <div className='col-12'>
                                        <label htmlFor='notice_description' className="form-label fw-medium">Notice Description</label>
                                        <textarea
                                            className="form-control"
                                            name="notice_description"
                                            id='notice_description'
                                            placeholder="Enter here..."
                                            rows="7"
                                            value={formData.notice_description || ''}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                {/* save/Cancel */}
                                <div className='d-flex justify-content-center mt-4 gap-2'>
                                    <button type='submit' className='btn btn-success'>
                                        {isEditing ? 'UPDATE' : 'SAVE'}
                                    </button>
                                    <button type='button' className='btn btn-danger'
                                        onClick={() => {
                                            resetForm();
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}
                    {/* TABLE */}
                    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                        <table className='table table-bordered table-striped text-center table-sm align-middle'>
                            <thead className='table-info'>
                                <tr>
                                    <th>SL</th>
                                        <th>Action</th>
                                    <th>Notice Date</th>
                                    <th>Department</th>
                                    <th>Role</th>
                                    <th>Notice</th>
                                
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.length > 0 ? (
                                    filteredData.map((notice, idx) => (
                                        <tr key={idx}>
                                            <td>{idx + 1}</td>
                                               <td>
                                                <button className='btn btn-sm btn-primary mx-1' onClick={() => handleEdit(notice.id)}><AiOutlineEdit size={18} /></button>
                                                <button className='btn btn-sm btn-danger mx-1'
                                                    onClick={() =>
                                                        showConfirmDialog({
                                                            title: 'Delete Notice',
                                                            message: `Are you sure you want to delete this notice ?`,
                                                            onConfirm: () => handleDelete(notice.id),
                                                        })
                                                    }
                                                >
                                                    <AiOutlineDelete size={18} />
                                                </button>

                                                  <button
    className='btn btn-sm btn-success mx-1'
    onClick={() => handleDownloadNotice(notice)}
>
    <GoDownload size={18}/>
</button>
                                            </td>
                                            <td>{notice.notice_date}</td>
                                            <td>{notice.department}</td>
                                            <td>{notice.role}</td>
                                            <td>
                                                <button
                                                    className="btn btn-sm btn-info"
                                                    onClick={() => {
                                                        setSelectedNotice(notice.notice_description);
                                                        setShowNoticeModal(true);
                                                    }}
                                                >
                                                    View Notice
                                                </button>
                                            </td>
                                         
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="text-center text-danger fw-bold text-muted">No data found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <Modal
                show={showNoticeModal}
                onHide={() => setShowNoticeModal(false)}
                centered
                size="md"
                backdrop="static"
            >
                <Modal.Header closeButton className="bg-primary text-white">
                    <Modal.Title className="fw-bold">Notice Detail</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="p-3 border rounded shadow-sm bg-light">
                        <p className="mb-0" style={{ whiteSpace: 'pre-line' }}>
                            {selectedNotice}
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="outline-danger"
                        onClick={() => setShowNoticeModal(false)}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <ToastNotification
                show={toast.show}
                message={toast.message}
                bg={toast.bg}
                onClose={() => setToast({ ...toast, show: false })}
            />
            <ConfirmDialog
                show={confirmDialog.show}
                title={confirmDialog.title}
                message={confirmDialog.message}
                onConfirm={confirmDialog.onConfirm}
                onCancel={() => setConfirmDialog({ ...confirmDialog, show: false })}
            />
        </>
    )
}

export default NoticeBoard